import type { RouteDef } from '@/app/routes'
import type { WrittenPage } from '../sections'

/**
 * Where a link lands when it does not open — expired, mistyped, or truncated by
 * a mail client that wrapped the URL.
 *
 * IT GETS ITS OWN PAGE RATHER THAN AN ERROR, because the person clicking did
 * nothing wrong and the useful thing is a way forward, not a status code. It
 * also never says WHY: "that link expired" and "that link was never valid" are
 * the same sentence to a reader and the difference is only useful to somebody
 * probing.
 */
export const route: RouteDef = {
  id: 'newsletterExpired',
  path: 'newsletter/expired',
  priority: 0.1,
  robots: 'noindex',
}

export const newsletterExpired: WrittenPage = {
  navLabel: 'Link no longer works',
  title: 'That link no longer works',
  description: 'The link has expired or is not valid.',
  sections: [
    {
      kind: 'prose',
      align: 'center',
      heading: 'That link no longer works',
      sub: 'Confirmation links are good for a week.',
      paragraphs: [
        'If you were confirming a subscription, enter your address again at the bottom of any page and we will send a fresh link.',
        'If you were trying to unsubscribe and this did not work, reply to any email from us and we will take the address off by hand.',
      ],
      cta: { label: 'Back to the site', href: '/' },
    },
  ],
}
